import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import nl from '@fullcalendar/core/locales/nl';
import {Tooltip} from "bootstrap";

class CalendarComponent {
	constructor() {
		let calendarEl = document.getElementById('calendar');
		if (! calendarEl) {
			return;
		}
		let eventsConfig = JSON.parse(calendarEl.dataset.events);
		let calendar = new Calendar(calendarEl, {
			plugins: [ dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin, bootstrap5Plugin],
			events: eventsConfig,
			locale: nl,
			buttonText : {
				today : 'Vandaag',
				month : 'Maand',
				week : 'Week',
				day : 'Dag',
				list : 'Lijst',
			},
			initialView: 'listMonth',
			defaultView: 'listMonth',
			eventDisplay : 'block',
			eventColor : '#e47a72',
			eventBorderColor : '#ac2a1f',
			displayEventEnd : true,
			eventTimeFormat : { // like '14:30:00'
				hour: '2-digit',
				minute: '2-digit',
				hour12: false
			},
			titleFormat: (info) => `Bijbelleesrooster 75 jaar kapel`,
			headerToolbar: {
				left: '',
				center: 'title',
				right: ''
			},
			initialDate:'2025-10-26',
			validRange: {
				start: '2025-10-26',
				end: '2017-10-29'
			},
			themeSystem : 'bootstrap5',
			dateClick: (info) => this.dateClick(info),
			eventDidMount: function(info) {
				var tooltip = new Tooltip(info.el, {
					title: info.event.extendedProps.full_title,
					placement: 'top',
					trigger: 'hover',
					container: 'body'
				});
			},
			eventClick:  function(event, jsEvent, view) {
				console.log(event.event.extendedProps);
				$('#modalTitle').html(event.event.extendedProps.full_title);
				$('#modalBody').html(event.event.extendedProps.description);
				$('#eventUrl').attr('href',event.url);
				// console.log($('#calendarModal'));
				let calendarModal = new bootstrap.Modal(document.getElementById('calendarModal'))
				calendarModal.show();
			}
		});
		calendar.setOption('locale', 'nl');
		calendar.render();
	}
	dateClick(info) {
		// change the day's background color just for fun
		info.dayEl.style.backgroundColor = 'var(--bs-gray-200)';
		setTimeout(function() {
			info.dayEl.style.backgroundColor = '';
		}, 2500);

		$('input[name="date"]').val(this.getFormattedDate(info.date));
		$('input[name="date"]')[0].scrollIntoView({behavior: 'smooth'});
	}
	getFormattedDate(date) {
		let month = ('0' + (date.getMonth() + 1)).slice(-2);
		let day   = ('0' + date.getDate()).slice(-2);
		let year  = date.getFullYear();

		let htmlDate = year + '-' + month + '-' + day;
		return htmlDate;
	}
}
export default CalendarComponent;
